import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectRetreatSendsAt, selectBenchPosition } from './selectors';
import { selectActivePokemon, selectBench } from '../ActiveGame/selectors';

/** Seconds left until `at`, ticking down while it's in the future. */
function useSecondsUntil(at) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    if (!at) {
      return undefined;
    }
    const timer = setInterval(() => setNow(Date.now()), 250);
    return () => clearInterval(timer);
  }, [at]);
  return at ? Math.max(0, Math.ceil((at - now) / 1000)) : 0;
}

/**
 * The retreat waiting for its Undo, in words for the turn banner, or null when none is waiting: "Charmeleon goes to
 * the Bench and Machop comes up in 3 s."
 */
export default function useRetreatUndo(userId) {
  const sendsAt = useSelector(selectRetreatSendsAt);
  const benchPosition = useSelector(selectBenchPosition);
  const active = useSelector((state) => selectActivePokemon(state, { userId }));
  const bench = useSelector((state) => selectBench(state, { userId }));
  const seconds = useSecondsUntil(sendsAt);

  if (!sendsAt) {
    return null;
  }
  const coming = bench && bench.get('cards').find(card => card.get('order') === benchPosition);
  const name = (pokemon) => (pokemon ? pokemon.getIn(['card', 'name'], pokemon.get('name')) : 'Your Pokémon');
  return {
    title: 'Retreating',
    hint: seconds > 0
      ? `${name(active)} goes to the Bench and ${coming ? name(coming) : 'the benched Pokémon'} comes up in ${seconds} s.`
      : 'Retreating…',
  };
}
